/**
 * Defines the initial state of the unsavedChangesGuard module.
 */

import { UnsavedChangesGuardState } from './types/unsavedChangesGuard.types';

const state: UnsavedChangesGuardState = {
  isModalActive: false,
  userSelectedKeepEditing: false,
  apiState: {},
  isUnsavedChangesDialogActive: false,
};

export default state;
